export default "/images/03b35971242e97bb4bb6351acfd5a577.avif";